/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_GROUP_PARTICIPANT } from "./actionTypes"
import { apiError, addGroupParticipantSuccess } from "./actions"

//Include Both Helper File with needed methods
import { insertGroupParticipant } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(insertGroupParticipant, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al agregar el usuario")
    yield put(addGroupParticipantSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* groupParticipantAddSaga() {
  yield takeEvery(ADD_GROUP_PARTICIPANT, add)
}

export default groupParticipantAddSaga
